import { emulatorScreen, mobileScreen } from "../../utils/styleUtils";

const styles = (theme) => ({
  quizScreenContainer: {
    height: "100vh",
    backgroundColor: "#ecf2f1",
  },

  questionImg: {
    width: "150px",
    height: "150px",
    position: "absolute",
    zIndex: "5",
  },

  includedTitle: {
    color: "#003e4c",
    fontSize: "46px",
    fontWeight: "500",
    fontFamily: "Oswald",
  },

  serviceTitle: {
    color: "#003e4c",
    fontSize: "20px",
    fontWeight: "500",
    fontFamily: "Oswald",
    marginBottom: "4px",
  },

  serviceDesc: {
    color: "#003e4c",
    fontSize: "15px",
    fontWeight: "400",
    fontFamily: "Rubik",
    maxWidth: "350px",
    lineHeight: "1.2",
  },

  dropImageStyle: {
    width: "400px",
    height: "100px",
  },

  draggableDrop: {
    border: "3px solid #003e4c",
    borderRadius: "6px",
    backgroundColor: "#fff",
    width: "410px",
  },

  answerTitleIcon: {
    width: "90px",
    height: "40px",
    marginRight: "1.5rem",
  },

  answerTitleContainer: {
    backgroundColor: "#003e4c",
    padding: "0.7rem 1rem",
  },

  answerTitleText: {
    color: "#fff",
    fontSize: "25px",
    fontWeight: "500",
    fontFamily: "Oswald",
  },

  answerDescContainer: {
    padding: "0 1rem 1rem 1rem",
    height: "210px",
  },

  droppableCircle: {
    width: "70px",
    height: "70px",
    borderRadius: "50%",
    marginTop: "1rem",
    border: "3px dashed #003e4c",
  },

  droppableAnswer: {
    width: "79px",
    height: "79px",
    borderRadius: "50%",
    marginTop: "1rem",
  },

  submitButton: {
    backgroundColor: "#00b1d9",
    color: "#fff",
    fontSize: "30px",
    fontWeight: "500",
    padding: "0px 20px",
    borderRadius: "5px",
    fontFamily: "'Oswald', sans-serif",
    "&:hover": {
      backgroundColor: "#056f8a",
    },
    [mobileScreen(theme)]: {
      fontSize: "18px",
      padding: "0px 10px",
    },
  },

  evaluatorModalContainer: {
    width: "32%",
    padding: "0rem 3rem",
    backgroundColor: "#fff",
    borderRadius: "6px",
    [mobileScreen(theme)]: {
      padding: "0rem 2rem",
      width: "42%",
      // width: "240px"
    },
  },
  mainLine: {
    // margin: "24px 0",
    color: "#003e4c",
    fontFamily: "Rubik",
    fontSize: 16,
    [mobileScreen(theme)]: {
      // margin: "12px 0",
      fontSize: '0.7rem'
    },
  },

  stepNumber: {
    fontSize: 30,
    fontWeight: 600,
    textAlign: 'center',
    padding: '20px 0px',
    color: '#003e4c',
    fontFamily: "Rubik",
    [mobileScreen(theme)]: {
      padding: '10px 0px',
      fontSize: 18,
    },
  },

  evalDesc: {
    paddingTop: 30,
    // margin: "24px 0",
    color: "#003e4c",
    fontFamily: "Rubik",
    fontSize: 16,
    [mobileScreen(theme)]: {
      paddingTop: 12,
      fontSize: '0.7rem'
    },
  },
  evalList: {
    padding: "0px 10px 10px 10px",
    margin: 0,
    color: "#003e4c",
    fontFamily: "Rubik",
    [mobileScreen(theme)]: {
    },
  },

  correctIncorrectIcon: {
    width: "200px",
    height: "45px",
    [mobileScreen(theme)]: {
      width: "120px",
      height: "30px",
    },
  },
});

export default styles;
